import { Routes, Route } from "react-router-dom"
import { PrimeReactProvider } from 'primereact/api';

import "./assets/css/bootstrap.min.css"


import "./assets/css/all-fontawesome.min.css"
import "./assets/css/animate.min.css"
import "./assets/css/magnific-popup.min.css"
// import "./assets/css/owl.carousel.min.css"
import "./assets/css/jquery-ui.min.css"
import "./assets/css/jquery.timepicker.min.css"
import "./assets/css/nice-select.min.css"

import "./assets/css/style.css"
import "./assets/css/custom.css"

// import "primereact/resources/themes/lara-light-cyan/theme.css";

import HomePage from "./pages/HomePage"
import AboutPage from "./pages/AboutPage"
import PrivacyPage from "./pages/PrivacyPage"
import ContactPage from "./pages/ContactPage"
import TaxiDoPage from "./pages/TaxiDoPage"
import TermsPage from "./pages/TermsPage"
import BlogPage from "./pages/BlogPage";
import FaqPage from "./pages/FaqPage";



function App() {
  return (
    <div className="App">
      <PrimeReactProvider>
        <Routes>
          <Route path="/" element={<HomePage/>}/>
          <Route path="/about" element={<AboutPage/>}/>
          <Route path="/privacy" element={<PrivacyPage/>}/>
          <Route path="/contact" element={<ContactPage/>}/>
          <Route path="/taxido" element={<TaxiDoPage/>}/>
          <Route path="/terms" element={<TermsPage/>}/>
          <Route path="/blog" element={<BlogPage/>}/>
          <Route path="/faq" element={<FaqPage/>}/>
        </Routes>
      </PrimeReactProvider>
    </div>
  );
}

export default App;
